import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import "./InputOptionDownloadComponent.css";

const InputOptionDownloadComponent = ({ disabled, options, onSelect }) => {
  const [anchorMenu, setAnchorMenu] = useState(null);
  const isOptionOpen = Boolean(anchorMenu);

  // const openOption = (event) => {
  //   setAnchorMenu(event.currentTarget);
  // };

  const closeOption = () => {
    setAnchorMenu(null);
  };

  const Option = (option) => {
    setAnchorMenu(null);
    onSelect(option);
  };

  return (
    <div className='input-option-download'>
      <Button
        disabled={disabled}
        // endIcon={isOptionOpen ? <UpIcon /> : <DownIcon />}
        startIcon={<DownloadIcon />}
        variant='contained'
        className='!normal-case'
        onClick={() => onSelect("csv")}
        // onClick={openOption} // To show options, uncomment this
      >
        Download csv file
      </Button>

      <Menu anchorEl={anchorMenu} open={isOptionOpen} onClose={closeOption}>
        {options.map((option) => (
          <MenuItem
            className='input-option-download-label'
            key={option}
            onClick={() => Option(option)}
          >
            .{option} file
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default InputOptionDownloadComponent;
